var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/_lodash@4.17.4@lodash/_Symbol.js
// module id = 91
// module chunks = 0 1